import React from 'react';

export const sa = {
  page: { minHeight: '100vh', background: '#0A0A0A', color: '#fff', fontFamily: "'DM Sans', sans-serif" },
  heading: { fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, letterSpacing: '-0.01em', textTransform: 'uppercase' },
  overline: { fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#A1A1AA', fontWeight: 700 },
  surface: { background: '#141414', border: '1px solid #27272A' },
  input: {
    width: '100%', background: '#0A0A0A', border: '1px solid #27272A', color: '#fff', padding: '10px 12px',
    fontSize: 14, outline: 'none', fontFamily: 'inherit',
  },
  label: { display: 'block', fontSize: 12, color: '#A1A1AA', marginBottom: 6, fontWeight: 600, letterSpacing: '0.04em' },
};

export const SaButton = ({ children, variant = 'primary', style, ...props }) => {
  const base = {
    padding: '9px 16px', fontWeight: 700, fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase',
    cursor: props.disabled ? 'not-allowed' : 'pointer', border: '1px solid transparent', display: 'inline-flex',
    alignItems: 'center', gap: 6, transition: 'background-color .15s, border-color .15s, transform .15s',
    opacity: props.disabled ? 0.5 : 1, fontFamily: 'inherit',
  };
  const variants = {
    primary: { background: '#D90000', color: '#fff' },
    ghost: { background: 'transparent', color: '#fff', borderColor: '#27272A' },
    danger: { background: 'transparent', color: '#FF6B6B', borderColor: '#5c1a1a' },
    dark: { background: '#0A0A0A', color: '#fff', borderColor: '#3f3f46' },
  };
  return (
    <button type="button" {...props} style={{ ...base, ...variants[variant], ...style }}>
      {children}
    </button>
  );
};

export const StatusPill = ({ status }) => {
  const map = {
    active: { bg: 'rgba(34,197,94,.12)', fg: '#4ade80', border: '#166534' },
    suspended: { bg: 'rgba(245,158,11,.12)', fg: '#fbbf24', border: '#78350f' },
    onboarding: { bg: 'rgba(59,130,246,.12)', fg: '#60a5fa', border: '#1e3a8a' },
    deleted: { bg: 'rgba(217,0,0,.12)', fg: '#ff6b6b', border: '#7f1d1d' },
  };
  const c = map[status] || map.deleted;
  return (
    <span data-testid={`company-status-${status}`} style={{
      background: c.bg, color: c.fg, border: `1px solid ${c.border}`, padding: '3px 10px', fontSize: 11,
      fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase',
    }}>{status}</span>
  );
};

export const Modal = ({ title, onClose, children, width = 520, testId }) => (
  <div
    onClick={onClose}
    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.72)', backdropFilter: 'blur(6px)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
  >
    <div data-testid={testId} onClick={(e) => e.stopPropagation()} style={{ ...sa.surface, width: '100%', maxWidth: width, padding: 28, boxShadow: '0 30px 80px rgba(0,0,0,.6)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h3 style={{ ...sa.heading, fontSize: 26, margin: 0 }}>{title}</h3>
        <button type="button" onClick={onClose} data-testid="modal-close-btn" style={{ background: 'none', border: 'none', color: '#A1A1AA', fontSize: 22, cursor: 'pointer' }}>×</button>
      </div>
      {children}
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={sa.label}>{label}</label>
    {children}
  </div>
);

// FastAPI returns validation errors as an array of objects; normalise anything to a readable string.
export const errMsg = (e, fallback = 'Request failed') => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => (x?.loc ? `${x.loc.slice(-1)[0]}: ` : '') + (x?.msg || JSON.stringify(x))).join('; ');
  if (d && typeof d === 'object') return d.msg || JSON.stringify(d);
  return d || e?.message || fallback;
};
